// extracted by mini-css-extract-plugin
export default {"consumerHeaderSearchBar":"ConsumerHeaderSearchBar-module__consumerHeaderSearchBar___gCQUP"};